import { initialized, me, gameId, master } from "../store"

export default async () => {
  let local = window.localStorage.getItem("me")
  if (location.hash) {
    const hash = location.hash.replace("#", "").split("___")
    gameId.set(hash[0])
    if (hash[1] && hash[1] === "trex") {
      master.set(true)
    }
  }
  if (local) {
    local = JSON.parse(local)
    if (local.name) {
      me.set(local)
    }
  }
  initialized.set(true)
}
